const PascalCase = (str) => {
    if (!str || typeof str !== 'string') return "";

    return str.trim().split(/\s+/).map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ')
};

export default PascalCase;